var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD000",
  d: "M9.889.148c.06-.197.16-.197.22 0l2.162 7.06a.53.53 0 00.467.38h6.995c.196 0 .228.098.067.223l-5.66 4.342a.577.577 0 00-.178.583l2.161 7.062c.06.196-.021.26-.178.136l-5.657-4.362a.5.5 0 00-.578 0l-5.66 4.366c-.157.12-.239.06-.178-.137l2.161-7.06a.577.577 0 00-.178-.584L.198 7.792C.041 7.67.07 7.568.266 7.568H7.26a.53.53 0 00.467-.378L9.89.148z"
})));

export default SvgStar;